import React from 'react';
import styles from './About.module.css';

const About = () => {
  const features = [
    {
      number: '01',
      title: 'Официально',
      description: 'Все чеки регистрируются в ФНС и имеют QR-код для проверки'
    },
    {
      number: '02',
      title: 'Конфиденциально',
      description: 'Никакие данные не попадают в открытый доступ'
    },
    {
      number: '03',
      title: 'Быстро',
      description: 'Изготовление от 1 часа с доставкой по Москве'
    },
    {
      number: '04',
      title: 'Надежно',
      description: 'Гарантия прохождения любой проверки'
    }
  ];

  return (
    <section id="about" className={`section ${styles.about}`}>
      <div className="container">
        <div className={styles.aboutContent}>
          <div className={styles.aboutInfo}>
            <div className={styles.aboutBadge}>
              <span>О КОМПАНИИ</span>
            </div>
            
            <h2 className={styles.aboutTitle}>
              Чеки <span className={styles.titleAccent}>Москва</span>
            </h2>
            
            <div className={styles.aboutText}>
              <p>
                <strong>Чеки Москва</strong> — ведущий поставщик официальных кассовых чеков 
                с QR-кодом в столице. Мы работаем на рынке с 2015 года и заслужили доверие 
                сотен компаний и частных клиентов.
              </p>
              
              <p>
                Наша специализация — предоставление 100% легитимных кассовых документов 
                для всех видов отчетности. Мы сотрудничаем с действующими предприятиями 
                Москвы, что гарантирует абсолютную законность всех выдаваемых документов.
              </p>
              
              <p>
                Конфиденциальность клиента — наш главный приоритет. Все операции проводятся 
                с соблюдением высочайших стандартов безопасности и анонимности.
              </p>
            </div>
            
            <div className={styles.stats}>
              <div className={styles.stat}>
                <span className={styles.statNumber}>8+</span>
                <span className={styles.statLabel}>Лет на рынке</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statNumber}>5000+</span>
                <span className={styles.statLabel}>Довольных клиентов</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statNumber}>100%</span>
                <span className={styles.statLabel}>Подтверждение ФНС</span>
              </div>
            </div>
          </div>
          
          <div className={styles.aboutFeatures}>
            {features.map((feature, index) => (
              <div key={index} className={`card ${styles.featureCard}`}>
                <div className={styles.featureNumber}>{feature.number}</div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
        
        <div className={styles.aboutCta}>
          <div className={styles.ctaContent}>
            <h3 className={styles.ctaTitle}>Нужен срочно чек?</h3>
            <p className={styles.ctaText}>
              Свяжитесь с нами прямо сейчас и получите готовый документ 
              в течение 1-2 часов с доставкой по Москве
            </p>
          </div>
          <a href="#contact" className="btn btn--primary">
            <i className="fas fa-bolt"></i>
            СРОЧНЫЙ ЗАКАЗ
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;